class SizeGuideCta extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.sizeGuide = this.querySelector('.ks-chart-modal-link');
    // if (!this.sizeGuide) { this.remove(); }
    this.addEventListener('click', () => { this.openSizeGuide(); });
  }
  openSizeGuide() {
    if (this.sizeGuide) { this.sizeGuide.click(); }
  }
}
customElements.define('size-guide-cta', SizeGuideCta);